import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import ReportDetail from "../../components/report/ReportDetail";

const { Content } = Layout;

function ReportMag({ match }) {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">
            <Content className="layout-content">
               <ReportDetail/>
            </Content>
         </Layout>
      </Layout>
   );
}

export default ReportMag;
